'use client';

import { WEBSITE_URL } from '@/config-global';
import { useLocalToken } from '@/hooks/use-local-token';
import ParentPlausibleProvider from 'next-plausible';
import { Suspense } from 'react';

type Props = {
  children: React.ReactNode;
};

function extractRootDomain(url: string): string {
  const match = url.match(
    /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/im,
  );
  return match?.[1] || '';
}

export default function PlausibleProvider({ children }: Props) {
  const domain = extractRootDomain(WEBSITE_URL) as string;
  useLocalToken();

  return (
    <ParentPlausibleProvider
      domain={domain}
      customDomain="https://trck222.com"
      scriptProps={{
        defer: true,
        async: true,
      }}
    >
      <Suspense fallback={null}>{children}</Suspense>
    </ParentPlausibleProvider>
  );
}
